import { render, staticRenderFns } from "./OrdersCollapse.vue?vue&type=template&id=dab93348&"
import script from "./OrdersCollapse.vue?vue&type=script&lang=js&"
export * from "./OrdersCollapse.vue?vue&type=script&lang=js&"
import style0 from "./OrdersCollapse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports